import React from "react";
import { View } from "react-native";

import { buttonStyle } from "../common/ActionsMenuButton/utils";
import ActionButton from "../common/ActionsMenuButton/ActionButton";
import AppTheme from "../AppTheme";
import IntegrationIcons from "../common/icons/integrations/index";

export default function IntegrationsHistoryFabButton({
  mariOptions = {},
  style = {},
  viewIgnored = () => {},
}) {
  return (
    <View style={[buttonStyle, style]}>
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"IntegrationsBlacklistFabButton"}
      >
        <ActionButton.Item
          hideShadow
          key={6}
          buttonColor="#FFF"
          title="View Ignored"
          onPress={viewIgnored}
        >
          <IntegrationIcons.HiddenIcon />
        </ActionButton.Item>
        ,
      </ActionButton>
    </View>
  );
}
